import React, { useCallback, useState, createContext, useContext } from 'react';
import { en } from './translations/en';
import { fr } from './translations/fr';
import { es } from './translations/es';
import { pt } from './translations/pt';
export type Language = 'EN' | 'FR' | 'ES' | 'PT';
type Translations = Record<string, string>;
const translationMap: Record<Language, Translations> = {
  EN: en,
  FR: fr,
  ES: es,
  PT: pt
};
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextType>({
  language: 'EN',
  setLanguage: () => {}
});
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('EN');
  return <LanguageContext.Provider value={{
    language,
    setLanguage
  }} data-id="element-316">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  return useContext(LanguageContext);
}
export function useTranslation() {
  const {
    language
  } = useLanguage();
  const t = useCallback((key: string): string => {
    const dict = translationMap[language];
    return dict[key] ?? translationMap['EN'][key] ?? key;
  }, [language]);
  return {
    t,
    language
  };
}